import React from 'react';

import { currencyFormat, CurrencyCode } from 'utils/currencyFormat';

const Counter = ({
  label,
  amount,
  accountCurrency,
  isFirst = false,
}: {
  label: string;
  amount: number;
  accountCurrency: CurrencyCode;
  isFirst?: boolean;
}): JSX.Element => (
  <div style={{ fontSize: 12, marginLeft: isFirst ? 0 : 24 }}>
    {label}
    <span style={{ fontWeight: 'bold', marginLeft: 6 }}>
      {currencyFormat(amount, accountCurrency)}
    </span>
  </div>
);

export default Counter;
